import React, { useCallback, useState } from 'react';
import { NavLink, Redirect } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import { themeButtons } from "../../css/themeButtons";
import { Field, Form, Formik } from "formik";
import Box from "@material-ui/core/Box";

const confirmationMessage = {
  "whatsapp": "Вам отправлено сообщение на WhatsApp c инструкцией по восстановлению пароля",
  "viber": "Вам отправлено сообщение на Viber c инструкцией по восстановлению пароля",
  "email": "Вам отправлено письмо на электронную почту c инструкцией по восстановлению пароля",
}

const ForgotPassword = (props) => {
  const { userIsAuth, passwordChangeRequest } = props

  const [confirmationType, setConfirmationType] = useState()
  const [loginError, setLoginError] = useState(null)

  const validate = useCallback((values) => {
    const errors = {}

    if (!values.login) errors.login = 'Поле не заполнено'
    if (loginError) errors.login = loginError

    setLoginError(null);

    return errors;
  }, [loginError])

  const onSubmit = async (values, { validateForm }) => {

    let res = await passwordChangeRequest(values)

    if (!res.status) {
      setLoginError(() => res.data.message)
      validateForm()
    } else {
      setConfirmationType(res.data.type)
    }
  }


  const buttons = themeButtons();


  if (userIsAuth) {
    return <Redirect to="/lk"/>
  }
  return (
    <div className="main ps-0">
      <div className="container-fluid">
        {confirmationType && <div className="col-md-12">
          <Box className="alert alert-success">
            {confirmationMessage[confirmationType]}
          </Box>
        </div>}
        <div className="forgot-password">
          <div className="login-card mb-4">
            <Typography variant={"h4"} className={"mb-2"}>Восстановление пароля</Typography>

            <Box className="alert alert-warning mb-3 d-flex flex-column">
              <span>Если вы зарегистрировались по номеру телефона - введите номер телефона</span>
              <span>Если вы зарегистрировались по E-mail - введите адрес электронной почты</span>
            </Box>

            <Formik validate={validate}
                    initialValues={{ login: '' }}
                    enableReinitialize
                    onSubmit={onSubmit}>
              {({ isSubmitting, errors, touched }) => (
                <Form>
                  <div className="row">
                    <div className="col-12 mb-3">
                      <Field name="login">
                        {({ field, form }) => (
                          <TextField size="small"
                                     {...field}
                                     type="text" variant="outlined"
                                     className={"w-100"}
                                     label="Логин, указанный при регистрации"
                                     error={Boolean(errors.login && touched.login)}
                                     helperText={(
                                       errors.login &&
                                       touched.login &&
                                       String(errors.login)
                                     )}
                          />
                        )}
                      </Field>

                      <p className="small text-muted text-center mt-0">На данный контакт будет
                        отправлена информация по восстановлению
                        пароля</p>
                    </div>
                  </div>
                  <div className="row text-center justify-content-center">
                    <div className='col-auto mb-2'>

                      <Button type="submit" disabled={isSubmitting}
                              className={`${buttons.btnGreen} px-5`}
                              variant="contained">Восстановить</Button>

                    </div>
                    <div className='col-12 mb-3 mt-2'>
                      <Link component={NavLink} to="/lk/login" variant="body1">
                        Вход в аккаунт
                      </Link>
                    </div>

                  </div>
                </Form>
              )}
            </Formik>

          </div>


        </div>
      </div>
    </div>
  );
}

export default ForgotPassword;
